import * as yup from 'yup';
import { checkExpiryDate, checkPostalCode } from './cardInfoValidator';
import { checkCreditCard } from './creditCardAuth';
import { AccountPanelTypes } from '../AccountPanelTypes';

export const cardInfoFormSchema = yup.object().shape({
  cardNumber: yup
    .string()
    .test(`checkCardValidation`, 'Invalid Card Details', (value?: string) => {
      return checkCreditCard(value);
    })
    .min(8, 'Too Short!')
    .max(24, 'Too Long!'),
  expiryDate: yup
    .string()
    .test(`expiryDateValidation`, 'Invalid Expiry Date', (value?: string) => {
      return checkExpiryDate(value);
    }),
  postalCode: yup
    .string()
    .test(`postalCodeValidation`, 'Invalid Code', (value?: string) => {
      return checkPostalCode(value);
    }),
  cvv: yup
    .string()
    .min(3, 'Too Short!')
    .max(5, 'Too Long!')
    .required('Required'),
  holderName: yup.string().required('Required'),
  address: yup.string().required('Required'),
  city: yup.string().required('Required'),
});

export const existingCardInfoFormSchema = yup.object().shape({
  amount: yup.string().required('Required'),
});

export const existingCardInfoHostedFormSchema = yup.object().shape({
  amount: yup.string(),
});

export const newFormikInitialValues: AccountPanelTypes.TCardDetailsFormInitialValues = {
  cardNumber: '',
  expiryDate: '',
  cvv: '',
  holderName: '',
  address: '',
  city: '',
  postalCode: '',
  amount: '',
  saveCardDetails: false,
  autoPay: false,
};

export const getExistingCardPaymentInitValues = (
  isAutoPayOptInEnabled: boolean = false
) => {
  return {
    amount: '',
    autoPay: isAutoPayOptInEnabled,
  };
};
